/* SOLA Jewelry — Theme JS */
'use strict';

function escapeHtml(str) {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/* ── Scroll reveal ── */
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

/* ── Cart drawer ── */
const cartDrawer  = document.getElementById('CartDrawer');
const cartOverlay = document.getElementById('CartOverlay');
const cartToggle  = document.getElementById('CartToggle');
const cartClose   = document.getElementById('CartClose');
const cartBody    = document.getElementById('CartBody');
const cartFooter  = document.getElementById('CartFooter');
const cartTotal   = document.getElementById('CartTotal');
const cartCount   = document.getElementById('CartCount');

function openCart()  { cartDrawer?.classList.add('open'); cartOverlay?.classList.add('open'); }
function closeCart() { cartDrawer?.classList.remove('open'); cartOverlay?.classList.remove('open'); }

cartToggle?.addEventListener('click', openCart);
cartClose?.addEventListener('click', closeCart);
cartOverlay?.addEventListener('click', closeCart);

async function fetchCart() {
  const res  = await fetch('/cart.js');
  const cart = await res.json();
  renderCart(cart);
}

const FREE_SHIPPING_THRESHOLD = 34900; // 349₪ in cents

function shippingBarHTML(totalCents) {
  const pct     = Math.min(100, Math.round(totalCents / FREE_SHIPPING_THRESHOLD * 100));
  const reached = totalCents >= FREE_SHIPPING_THRESHOLD;
  const remaining = formatMoney(FREE_SHIPPING_THRESHOLD - totalCents);
  const label   = reached
    ? '✦ משלוח חינם על ההזמנה שלכם'
    : `עוד ${remaining} למשלוח חינם`;
  return `
    <div class="shipping-bar-wrap">
      <p class="shipping-bar-label${reached ? ' shipping-bar-reached' : ''}">${label}</p>
      <div class="shipping-bar-track">
        <div class="shipping-bar-fill" style="width:${pct}%"></div>
      </div>
    </div>`;
}

function renderCart(cart) {
  if (!cartBody) return;
  if (cart.item_count === 0) {
    cartBody.innerHTML = '<div class="cart-empty"><p>העגלה ריקה</p></div>';
    cartFooter && (cartFooter.style.display = 'none');
  } else {
    cartBody.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item-img">
          <img src="${item.image}" alt="${escapeHtml(item.title)}">
        </div>
        <div class="cart-item-details">
          <p class="cart-item-title">${escapeHtml(item.product_title)}</p>
          <p class="cart-item-variant">${item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title || '') : ''}</p>
          <div class="cart-item-row">
            <p class="cart-item-price">${formatMoney(item.final_price)}</p>
            <button class="drawer-remove-btn" data-key="${item.key}" aria-label="הסר">✕</button>
          </div>
        </div>
      </div>
    `).join('');

    cartBody.querySelectorAll('.drawer-remove-btn').forEach(btn => {
      btn.addEventListener('click', async function() {
        const key = this.dataset.key;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        fetchCart();
      });
    });
    if (cartFooter) cartFooter.style.display = 'block';
    if (cartTotal)  cartTotal.textContent = formatMoney(cart.total_price);
    const barEl = document.getElementById('CartShippingBar');
    if (barEl) barEl.innerHTML = shippingBarHTML(cart.total_price);
  }
  if (cartCount) {
    cartCount.textContent = cart.item_count;
    cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
  }
}

function formatMoney(cents) {
  return '₪' + (cents / 100).toFixed(0);
}

/* ── Quick add ── */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-product-id]');
  if (!btn) return;
  e.preventDefault();
  btn.textContent = '...';
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.productId, quantity: 1 })
    });
    await fetchCart();
    openCart();
  } catch (err) {
    btn.textContent = 'ADD TO CART';
  }
});

/* ── Product page — gallery ── */
document.querySelectorAll('.product-gallery-thumb').forEach((thumb, i) => {
  thumb.addEventListener('click', () => {
    const mainImg = document.querySelector('.product-gallery-main img');
    if (mainImg) mainImg.src = thumb.querySelector('img').src.replace('_100x', '_800x');
    document.querySelectorAll('.product-gallery-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

/* ── Product page — variant select ── */
const productForm      = document.getElementById('product-form');
const variantsDataEl   = document.getElementById('ProductVariantsJSON');
const productVariants  = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : null;
const variantSections  = Array.from(document.querySelectorAll('.variant-section'));

function findMatchingVariant() {
  if (!productVariants) return null;
  const selected = variantSections.map(section => section.querySelector('.variant-btn.active')?.dataset.value);
  return productVariants.find(v => v.options.every((val, i) => val === selected[i])) || null;
}

function applyVariant(variant) {
  if (!variant) return;
  const idInput = productForm?.querySelector('[name="id"]');
  if (idInput) idInput.value = variant.id;

  const saleEl = document.querySelector('.price-sale');
  const origEl = document.querySelector('.price-original');
  if (saleEl) saleEl.textContent = variant.priceHtml;
  if (origEl) origEl.textContent = variant.origHtml;

  const addBtn = document.querySelector('.add-to-cart');
  if (addBtn) {
    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? 'ADD TO CART' : 'אזל המלאי';
  }
}

document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.variant-options');
    group?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const label = btn.closest('.variant-section')?.querySelector('.variant-current');
    if (label) label.textContent = btn.textContent;
    applyVariant(findMatchingVariant());
  });
});

/* ── Add to cart — product page ── */
const addToCartBtn = document.querySelector('.add-to-cart');
if (addToCartBtn) {
  addToCartBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    const variantId = document.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    addToCartBtn.textContent = 'ADDING...';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      await fetchCart();
      openCart();
      addToCartBtn.textContent = 'ADDED ✓';
      setTimeout(() => addToCartBtn.textContent = 'ADD TO CART', 2000);
    } catch {
      addToCartBtn.textContent = 'ADD TO CART';
    }
  });
}

fetchCart();
